/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {useState, useEffect} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../../../store/store';
import Finances from '../../../widgets/Finances';
import Carousel from '../../../shared/Carousel';
import posterImg from '../../../../_metronic/assets/media/17-dark.png';
import {Button} from '../../../shared/Buttons';
import Card from '../../../shared/Card';
import PageWrapper from '../../../modules/PageWrapper';
import {Link} from 'react-router-dom';
import Chart from '../../../widgets/Chart';
import {formatNumberToCash, formatNumber, formatNumber2} from '../../../functions/formatNumber';

const DashboardPage = observer(({timeConfig, isVerify, setPreloader}) => {
  const store = useStore();

  const [salesStats, setSalesStats] = useState({});
  const [qualificationSchedule, setQualificationSchedule] = useState([]);
  const [ltcStats, setLtcStats] = useState();
  const [forecast, setForecast] = useState();

  useEffect(() => {
    isVerify && timeConfig.time_config && getData();
  }, [isVerify, timeConfig]);

  const getData = async () => {
    const getSalesStats = await store.requestGet(
      `user/sales/ltc/manager/statistics`,
      {
        params: timeConfig,
      },
      true
    );
    const getLtcStats = await store.requestGet(`Dashboard/Sales/Ltc/Manager/getLtcStats`, {
      params: timeConfig,
    });
    const getForecast = await store.requestGet(`Dashboard/Sales/Ltc/Manager/getForecastPayout`);

    const ltcList = await store.requestGet('Finance/Category/getLtcList');

    const ltc = ltcList.find(
      (el) => +getLtcStats.ltc >= +el.ltc_min && +getLtcStats.ltc <= +el.ltc_max
    );

    if (!Object.keys(qualificationSchedule).length) {
      const getQualificationSchedule = await store.requestGet(
        `Dashboard/Sales/Ltc/Manager/qualificationSchedule`
      );
      setQualificationSchedule(getQualificationSchedule);
    }

    setForecast(getForecast);
    setLtcStats({...getLtcStats, indicator: ltc});
    setSalesStats(getSalesStats);
    setPreloader(false);
  };

  return (
    <>
      <div className='row g-5 g-xl-10 mt-0'>
        <div className='col-xl-4 mb-xl-10 mt-0'>
          <Finances
            background={'op'}
            title='Статистика'
            subTitle='Управляйте периодом в календаре.'
            stats={[
              {
                title: 'Чаты',
                number: formatNumber(salesStats?.chats_count) || 0,
                icon: (
                  <i className='ki-duotone ki-fingerprint-scanning fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                ),
              },
              {
                title: 'Регистрации',
                number: formatNumber(salesStats?.registrations_count) || 0,
                icon: (
                  <i className='ki-duotone ki-user-edit fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'Квалификации',
                number: formatNumber(salesStats?.qualifications_count) || 0,
                icon: (
                  <i className='ki-duotone ki-user-tick fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'LTC',
                number: `${formatNumber2(salesStats?.chat_to_qualification)}%` || 0,
                icon: (
                  <i className='ki-duotone ki-wallet fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                ),
              },
            ]}
          />
        </div>

        <div className='col-xl-8 mb-5 mb-xl-10 mt-xl-0'>
          <div className='row g-5 g-xl-10'>
            <div className='col-xl-6 mb-xl-10'>
              <Carousel title={'LTC'} subTitle={'Tекущие KPI'}>
                <div className={`carousel-item`}>
                  <div className='d-flex align-items-center mb-5'>
                    <div className='w-80px flex-shrink-0 me-2 symbol symbol-70px symbol-circle me-5'>
                      <span
                        className={`symbol-label bg-light-${ltcStats?.indicator?.indicator} w-70`}
                      >
                        <i
                          className={`ki-duotone ki-abstract-24 fs-3x text-${ltcStats?.indicator?.indicator}`}
                        >
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </span>
                    </div>

                    <div className='m-0'>
                      <h4 className='fw-bold text-gray-800 mb-3'>
                        {ltcStats?.ltc}%
                        <span
                          className={`badge badge-light-${ltcStats?.indicator?.indicator} fs-5 fw-bold`}
                        >
                          {ltcStats?.indicator?.name}
                        </span>
                      </h4>
                      <div className='d-flex d-grid gap-5'>
                        <div className='d-flex flex-column flex-shrink-0 me-4'>
                          <span className='d-flex align-items-center fs-7 fw-bold text-gray-400 mb-2'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Обращений: {formatNumber(ltcStats?.count_appeals)}
                          </span>

                          <span className='d-flex align-items-center text-gray-400 fw-bold fs-7'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Квалификаций: {formatNumber(ltcStats?.count_qualifications)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Link to={`/sales/ltc/kpi`}>
                    <Button color={'btn-primary'}>Подробнее</Button>
                  </Link>
                </div>
              </Carousel>
            </div>

            <div className='col-xl-6 mb-5 mb-xl-10'>
              <Carousel title={'Прогноз'} subTitle={'Прогноз выплаты за текущий период'}>
                <div className={`carousel-item active`}>
                  <div className='d-flex align-items-center mb-5'>
                    <div className='w-80px flex-shrink-0 me-2 symbol symbol-70px symbol-circle me-5'>
                      <span className={`symbol-label bg-light-primary w-70`}>
                        <i className={`ki-duotone ki-abstract-24 fs-3x text-primary`}>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </span>
                    </div>

                    <div className='m-0'>
                      <h4 className='fw-bold text-gray-800 mb-3'>
                        {formatNumberToCash(forecast?.payout)}
                        {/* <span
                          className={`badge badge-light-${rdStats?.indicator?.indicator} fs-5 fw-bold`}
                        >
                          {rdStats?.indicator?.indicator === 'danger' && 'Плохой результат'}
                          {rdStats?.indicator?.indicator === 'warning' && 'Средний результат'}
                          {rdStats?.indicator?.indicator === 'success' && 'Хороший результат'}
                        </span> */}
                      </h4>

                      <div className='d-flex d-grid gap-5'>
                        <div className='d-flex flex-column flex-shrink-0 me-4'>
                          <span className='d-flex align-items-center fs-7 fw-bold text-gray-400 mb-2'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Прогноз обращений: {formatNumber(forecast?.count_appeals)}
                          </span>

                          <span className='d-flex align-items-center text-gray-400 fw-bold fs-7'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Прогноз LTC: {forecast?.ltc}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Link to={`/sales/ltc/top/managers`}>
                    <Button color={'btn-primary'}>Подробнее</Button>
                  </Link>
                </div>
              </Carousel>
            </div>
          </div>

          <Card className='card' data-bs-theme='light' style={{backgroundColor: '#1C325E'}}>
            <div className='card-body d-flex ps-xl-15'>
              <div className='m-0'>
                <div className='position-relative fs-2x z-index-2 fw-bold text-white mb-7'>
                  <span className='me-2'>
                    Приведи менеджера и получи{' '}
                    <span className='position-relative d-inline-block text-danger'>
                      <span className='text-danger opacity-75-hover'>100$</span>

                      <span className='position-absolute opacity-50 bottom-0 start-0 border-4 border-danger border-bottom w-100'></span>
                    </span>
                  </span>
                  за каждого.
                  <br /> Условия по кнопке ниже!
                </div>
                <a
                  href='https://t.me/hr_hant'
                  target='_blank'
                  className='btn fw-bold  btn-danger cursor-pointer'
                  rel='noreferrer'
                >
                  Подробнее
                </a>
              </div>

              <img
                src={posterImg}
                className='position-absolute me-3 bottom-0 end-0 h-200px'
                alt=''
              />
            </div>
          </Card>
        </div>
        <div className='col-xl-12 mb-5 mb-xl-10 mt-0'>
          <Chart data={{graph: qualificationSchedule}} />
        </div>
      </div>
    </>
  );
});

const ManagerLTC = () => {
  return (
    <PageWrapper
      firstTimeConfig='current_week'
      mode='sales'
      breadcrumbs={[
        {title: 'PanelHunt', path: ''},
        {isSeparator: true},
        {title: 'Панель', path: '/dashboard/manager/ltc', isActive: true},
      ]}
      title={'Панель менеджера LTC'}
    >
      <DashboardPage />
    </PageWrapper>
  );
};

export default ManagerLTC;
